module.exports = __webpack_public_path__ + "img/id-card.10b01d5c.svg";